export default ({...props}) => {
  const {space, size} = props.theme
  return `
    display: flex;
    width: ${size(12.5)}%;
    justify-content: center;
    margin: ${space(2)}px 0;
    & > div {
        display: flex;
        margin: ${space(2)}px 0;
        width: ${size(11)}%;
        flex-flow: column;
        gap: ${space(10)}px;
    }
    `
}
